<template>
    <v-container fluid class="main-container d-block pa-0">
        <div class="container-form">
            <v-flex class="d-flex justify-space-between align-center pt-4">
                <div class="arrow-btn d-inline-flex" @click="back">
                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex rotate-90 common-text" />
                </div>
                <div v-if="controllerData" class="title-text controller-name">
                    {{controllerData.name}}
                </div>
                <div class="d-inline-flex"></div>
            </v-flex>
            <v-layout row class="d-inline-flex justify-center ma-0 mb-4">
                <span class="main-text green-text ml-2" v-if="controllerData.online">online</span>
                <span class="main-text red-text ml-2" v-else>offline</span>
            </v-layout>
            <v-tabs fixed-tabs grow v-model="tabControllerSelected" class="tabs-title ma-0">
                <v-tab key="devices" href="#devices" class="left-tab">
                    Физические устройства
                </v-tab>
                <v-tab key="form" href="#form" class="right-tab">
                    Локальные правила
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabControllerSelected" class="tabs-container" v-if="controllerData.uid">
                <v-tab-item key="devices" value="devices">
                    <DebugControllerDevices :controllerId="controllerId" :controllerFullData="controllerData"/>
                </v-tab-item>
                <v-tab-item key="form" value="form">
                    <DebugControllerForm :controllerId="controllerId" :controllerFullData="controllerData"/>
                </v-tab-item>
            </v-tabs-items>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import DebugControllerForm from "@/components/controllers/DebugControllerForm";
import DebugControllerDevices from "@/components/controllers/DebugControllerDevices";

export default {
    name: "DebugControllerPage",
    components: {ModalWaiting, DebugControllerForm, DebugControllerDevices},
    data() {
        return {
            controllerId: null,
            controllerData: {},
            openModalWaiting: false,
            tabControllerSelected: "devices",
        };
    },
    created() {
        this.controllerId = this.$route.params.id;
    },
    mounted() {
        if (this.controllerId) {
            this.getController();
        }
    },
    methods: {
        getController() {
            this.openModalWaiting = true;
            this.controllerData = {};
            this.$http.get('/controllers/home/controller/' + this.controllerId + '/')
                .then((response) => {
                    this.controllerData = response.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        back() {
            this.$router.push({name: "controllerspage"});
        },
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;
}

.controller-name {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: var(--rh-main-color);
    margin-bottom: 20px;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>